import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "cta",
  label: "Call to Action",
  description: "Rounded sage newsletter panel: headline and line beside an email field.",
  supportedPages: ["home", "shop", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Newsletter panel",
      fields: [
        { key: "title", label: "Heading", type: "string", default: "Subscribe to Our Newsletter" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get exclusive deals and new arrivals straight to your inbox." },
        { key: "placeholder", label: "Input Placeholder", type: "string", default: "Enter your email address" },
        { key: "buttonText", label: "Button Text", type: "string", default: "Subscribe" },
        { key: "bgColor", label: "Background Color", type: "color" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
